export type Gstr3bTable5ADrilldownMeta = {
  breadcrumbLabel: string;
  pageHeading: string;
};

const EXEMPT_NIL_META: Gstr3bTable5ADrilldownMeta = {
  breadcrumbLabel: 'From a supplier under Composition Scheme, Exempted and Nil Rated',
  pageHeading: 'From a supplier under Composition Scheme, Exempted and Nil Rated',
};

const NON_GST_META: Gstr3bTable5ADrilldownMeta = {
  breadcrumbLabel: 'Non-GST Supply',
  pageHeading: 'Non-GST Supply',
};

const TABLE_5A_DRILLDOWN_META: Record<string, Gstr3bTable5ADrilldownMeta> = {
  'exemptNil:interstate': {
    breadcrumbLabel: 'Interstate - Composition, Exempted and Nil',
    pageHeading:
      'Interstate supplies – From a supplier under Composition Scheme, Exempted and Nil Rated',
  },
  'exemptNil:intrastate': {
    breadcrumbLabel: 'Intrastate - Composition, Exempted and Nil',
    pageHeading:
      'Intrastate supplies – From a supplier under Composition Scheme, Exempted and Nil Rated',
  },
  'nonGst:interstate': {
    breadcrumbLabel: 'Interstate - Non-GST',
    pageHeading: 'Interstate supplies – Non-GST Supply',
  },
  'nonGst:intrastate': {
    breadcrumbLabel: 'Intrastate - Non-GST',
    pageHeading: 'Intrastate supplies – Non-GST Supply',
  },
};

const DEFAULT_TABLE_5A_DRILLDOWN_META: Gstr3bTable5ADrilldownMeta = {
  breadcrumbLabel: 'Table 5 Details',
  pageHeading: 'Table 5 Details',
};

const normalizeTable5ASection = (raw: string): 'exemptNil' | 'nonGst' | '' => {
  const lower = raw.trim().toLowerCase().replace(/[_-\s]/g, '');
  if (lower === 'nongst' || lower === 'nongstsupply') return 'nonGst';
  if (lower === 'exemptnil') return 'exemptNil';
  return '';
};

/** Resolves breadcrumb + page heading for Table 5 drill-down query params. */
export function getGstr3bTable5ADrilldownMeta(search: string): Gstr3bTable5ADrilldownMeta {
  const normalizedSearch = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(normalizedSearch);
  const section = normalizeTable5ASection(params.get('section') ?? '');
  const supplyScope = (params.get('supplyScope') ?? '').trim().toLowerCase();

  if (section && (supplyScope === 'interstate' || supplyScope === 'intrastate')) {
    return (
      TABLE_5A_DRILLDOWN_META[`${section}:${supplyScope}`] ?? DEFAULT_TABLE_5A_DRILLDOWN_META
    );
  }

  if (section === 'exemptNil') return EXEMPT_NIL_META;
  if (section === 'nonGst') return NON_GST_META;

  return DEFAULT_TABLE_5A_DRILLDOWN_META;
}

/** Parent Table 5 list link for drill-down breadcrumbs (keeps date range only). */
export function getGstr3bTable5AParentLink(search: string) {
  const normalizedSearch = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(normalizedSearch);
  const parentParams = new URLSearchParams();
  const fromDate = params.get('fromDate');
  const toDate = params.get('toDate');
  if (fromDate) parentParams.set('fromDate', fromDate);
  if (toDate) parentParams.set('toDate', toDate);
  const qs = parentParams.toString();
  return `/gstr3b/5.atable${qs ? `?${qs}` : ''}`;
}
